module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07445_logo_200x200.16aaef8d.png";